import dayjs, { Dayjs, extend, locale } from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export const FORMAT = 'YYYY-MM-DD'
export const MONTH_FORMAT = 'YYYY-MM'

extend(utc)
extend(timezone)
locale('ja')

export function NewDate(str: string | Date | Dayjs | null | undefined): Dayjs {
  if (!str) {
    return dayjs()
  }
  return dayjs(str)
}

export function Now(): Dayjs {
  return dayjs()
}

export function valiDate(d?: Dayjs): boolean {
  if (!d) return false
  return d.format(FORMAT) === '0001-01-01'
}

export function formatToHHmm(time: string): Dayjs | null {
  const timeRegex = /^([0-9]{1,2}):([0-9]{2})$/ // HH:mm形式チェック用の正規表現
  const match = time.match(timeRegex)
  if (match) {
    const hours = parseInt(match[1], 10)
    const minutes = parseInt(match[2], 10)

    return dayjs().hour(hours).minute(minutes).second(0)
  }
  return null
}
